/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { UtteranceEntityWithTextStore } from 'src/luis/projects/testPane/types/types';
import { EntityLabel } from 'src/luis/projects/utterances/types/Utterance';

/**
 * Given to utterance entities, this const determines whether these entities are the same entity or not,
 * based on the entity name, entity role and indices.
 *
 * @returns True if the entities are the same and false otherwise.
 */
export const isSameEntity = (a: UtteranceEntityWithTextStore, b: UtteranceEntityWithTextStore): boolean =>
    a.text === b.text &&
    a.utteranceEntity.entity.name === b.utteranceEntity.entity.name &&
    (a.utteranceEntity.startTokenIndex === null ||
        (a.utteranceEntity.startTokenIndex === b.utteranceEntity.startTokenIndex &&
            a.utteranceEntity.endTokenIndex === b.utteranceEntity.endTokenIndex)) &&
    (a.utteranceEntity.startCharIndex === null ||
        (a.utteranceEntity.startCharIndex === b.utteranceEntity.startCharIndex &&
            a.utteranceEntity.endCharIndex === b.utteranceEntity.endCharIndex)) &&
    (b.utteranceEntity.role.name !== '' || b.utteranceEntity.role === null || a.utteranceEntity.role === b.utteranceEntity.role);

/**
 * Sorts the utterance entities by their start indeces based on the type
 * we are using for comparison (character vs token) and if they are equal,
 * then we sort the by their names.
 *
 * @param a The first utterance entity.
 * @param b The second utterance entity.
 * @param useCharacterIndex A flag to whether use character indeces or token indeces.
 */
export const sortUtteranceEntities = (a: EntityLabel, b: EntityLabel, useCharacterIndex: boolean): number => {
    if (useCharacterIndex) {
        if (a.startCharIndex !== b.startCharIndex) {
            return a.startCharIndex > b.startCharIndex ? 1 : -1;
        }
    } else if (a.startTokenIndex !== b.startTokenIndex) {
        return a.startTokenIndex > b.startTokenIndex ? 1 : -1;
    }

    return a.entity.name > b.entity.name ? 1 : -1;
};
